export enum DocumentStatus {
    DRAFT = 'DRAFT',
    APPROVED = 'APPROVED',
    ARCHIVED = 'ARCHIVED',
    DONE = 'DONE',
}
  